import React, { Component } from "react";
import "../Git.css";

class Uni extends Component {
    render() {
        return (
            <div className="centercontent footermargin">
                <h1>ICT Engineering Studies</h1>

                <div className="descarea">
                    <div className="descbox">
                        <p>
                            I'm a second year Information and Communications Technology Engineering student in Finland.
                            Here you will find some details about what I've learned and what kind of experience
                            I've gathered from my studies.
                        </p>
                    </div>

                    <img id="img" src="..\imgs\avatar_yellow_portrait_small.jpg" alt="avatar icon"/>
                </div>

                <div className="tape projecttape">
                    <div className="page" style={{backgroundImage: "url('../imgs/projects/DeepDiveIntoJavaCode_U2_blur.jpg')"}}>
                        <h2><span>Networking Studies</span></h2>
                        <h4>Having completed courses in <span>switch networks</span> and <span>router networks</span>, I have gotten a lot of experience in building real networks
                            using <span>Cisco hardware</span>. In my studies, I've thoroughly learned concepts like <span>subnetting</span>, <span>VLAN</span>s,
                            the <span>OSI</span> and <span>TCP/IP</span> models along with switch and router configuration.<br></br><br></br>

                            {/* I have really enjoyed the networking classes, because I got to play with real hardware, which is important to me. I have also become
                            familiar with Cisco Packet Tracer to create larger, more complex networks and/or networks with expensive hardware. Most of the
                            assignments that I've done have been group assignments.<br></br><br></br> */}

                            In my second year we started more networking courses which are still on-going. I will be learning about switch and router configuration
                            more in-depth. I find learning networking very fun and easy with my methods. Seeing my fast progress is a really good confidence boost.
                        </h4>
                    </div>

                    <div className="page" style={{backgroundImage: "url('../imgs/projects/RainyViewFromAJapaneseAparetment_U2_blur.jpg')", backgroundPosition: "bottom", backgroundSize: "initial"}}>
                        <h2><span>Software Development</span></h2>
                        <h4>
                            I've done multiple software projects in groups using <span>Python</span>, <span>C#</span> and <span>WPF</span>.
                            These projects have provided me with great experience in <span>teamwork</span>, <span>project management</span>, and <span>project planning</span>.
                            In our projects we utilized <span>Scrum</span> with <span>Agile</span> and <span>LEAN</span> methods.<br></br><br></br>

                            Having previous software development experience, I ended up being in a project manager role in most group projects. I would 
                            handle meetings and take notes and teach my partners C# and general software development.<br></br><br></br>

                            I got the opportunity to start tutoring new students in their Python programming course.
                            This gives me more experience in multi-cultural communication with students and teachers.
                        </h4>
                    </div>
                </div>

                <div className="tape projecttape">
                    <div className="page" style={{backgroundImage: "url('../imgs/projects/LinuxUser_blur.jpg')", backgroundSize: "cover", backgroundPosition: "0 0px"}}>
                        <h2><span>Linux Knowledge</span></h2>
                        <h4>
                            Most of my <span>Linux knowledge</span> comes from using Linux at home. I've tried different Linux distributions as a <span>dual boot</span> installation.
                            I've tried to use Linux as my main driver as much as I can. I've also completed <span>Linux focused courses</span> in university.<br></br><br></br>

                            I've used <span>Raspberry Pi</span>s in vocational college as well as at home to create a custom ad blocking DNS. I will be doing more projects
                            with Raspberry Pis in the future.
                        </h4>
                    </div>

                    <div className="page" style={{backgroundImage: "url('../imgs/projects/CLIStuffIsWayCoolerThanUnityStuff_blur.jpg')", backgroundSize: "cover"}}>
                        <h2><span>Windows Active Directory</span></h2>
                        <h4>
                            Through a <span>Windows Active Directory</span> course, I've learned to set up and configure a <span>Windows Server</span> with <span>AD</span> and <span>DNS</span> in
                            a <span>virtual machine</span>.<br></br><br></br>

                            In the course, I set up multiple virtual machines as Windows 10 workstations using Oracle VM VirtualBox. These machines were connected to
                            two additional virtual machines working as Active Directory and DNS servers. The AD servers backed up each other using automatic data replication.
                            The servers also hosted intranet websites.
                        </h4>
                    </div>
                </div>
            </div>
        );
    }
}

export default Uni;